import { render, staticRenderFns } from "./Rounds.vue?vue&type=template&id=a167d534&scoped=true&"
import script from "./Rounds.vue?vue&type=script&lang=js&"
export * from "./Rounds.vue?vue&type=script&lang=js&"
import style0 from "./Rounds.vue?vue&type=style&index=0&id=a167d534&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a167d534",
  null
  
)

export default component.exports